import React from 'react'
import { TextFieldWithFormik } from '../common-components/with-formik/TextFieldWithFormik'

export const SurveyTextField: React.FC<{
  max: number
  min: number
  maxCharacters: number
  id: string
  numeric?: boolean
  rows?: number
  allowRowsToExpand?: boolean
  disabled?: boolean
  hideError?: boolean
  required?: boolean
}> = ({
  id,
  numeric = false,
  max,
  min,
  maxCharacters,
  rows,
  hideError,
  disabled,
  allowRowsToExpand = false,
  ...props
}) => {
  return (
    <TextFieldWithFormik
      {...props}
      name={id}
      maxInput={max}
      minInput={min}
      limit={maxCharacters}
      type={numeric ? 'number' : 'text'}
      disabled={disabled}
      variant='outlined'
      fullWidth
      minRows={rows ?? 4}
      maxRows={allowRowsToExpand ? undefined : rows ?? 4}
    />
  )
}
